/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import MobileFilterPopup from "./MobileFilterPopup";
import { useIsComponentMounted } from "../../../hooks/useIsComponentMounted";

const MobileFilterButton = ({
  value,
  setValue,
  open,
  setOpen,
  placeholder,
  Icon,
  data,
  variant = "text",
  valueRequired,
  inputRef,
}: {
  value: string;
  setValue: (value: string) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
  placeholder: string;
  Icon?: any;
  data:
    | { options: { label: string; value: string }[]; getRecords?: undefined }
    | {
        getRecords: (v: string) => Promise<{ label: string; value: string }[]>;
        options?: undefined;
      };
  variant?: "text" | "outlined";
  valueRequired?: boolean;
  inputRef?: any;
}) => {
  const isComponentMounted = useIsComponentMounted();

  const onClick = () => {
    if (!value) return setOpen(true);
    setOpen(!open);
  };

  useEffect(() => {
    if (!isComponentMounted) return;

    if (valueRequired && !value) {
      setOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isComponentMounted, valueRequired, setOpen]);

  return (
    <>
      {open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "rgba(15, 44, 82,.5)",
            zIndex: 105,
          }}
        />
      )}
      <div
        style={{
          width: "100%",
          overflow: "hidden",
        }}
      >
        {variant === "outlined" && !open && (
          <TextField
            fullWidth
            size="small"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            placeholder={placeholder}
            InputProps={{
              endAdornment: (
                <ArrowDropDownIcon
                  style={{
                    color: "rgba(0, 0, 0, 0.54)",
                    margin: 0,
                    padding: 0,
                  }}
                />
              ),
            }}
            onFocus={() => setOpen(true)}
            value={value}
          />
        )}

        {variant === "text" && !open && (
          <Button
            ref={inputRef}
            onFocusCapture={() => {
              if (open) return;
              setOpen(true);
            }}
            variant={variant}
            // fullWidth
            style={{
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textWrap: "nowrap",
              borderRadius: 4,
              height: 32,
              paddingLeft: 8,
              display: "flex",
              justifyContent: "flex-end",
              gap: 4,
              alignItems: "center",
              fontWeight: 400,
              fontSize: 14,
            }}
            onClick={onClick}
          >
            <div
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                textWrap: "nowrap",
              }}
            >
              {value || placeholder}
            </div>
            <ArrowDropDownIcon
              style={{
                color: "#005CA6",
                margin: 0,
                padding: 0,
              }}
            />
          </Button>
        )}
        {open && (
          <MobileFilterPopup
            value={value}
            setValue={setValue}
            setOpen={setOpen}
            placeholder={placeholder}
            Icon={Icon}
            data={data}
          />
        )}
      </div>
    </>
  );
};

export default MobileFilterButton;
